module.exports = __webpack_public_path__ + "img/MY.417cba3c.svg";